<template>
  <v-app>
    <v-progress-linear
      :indeterminate="true"
      class="ma-0"
      style="z-index:100"
      height="2"
      :active="loaderActive"
      absolute
      color="primary"
    />
    <si-announcement-bar :scroll-threshold="scrollThreshold" />
    <v-app-bar
      v-if="!$route.meta.hideMainAppBar"
      v-scroll="onScroll"
      fixed
      app
      elevate-on-scroll
      :scroll-threshold="scrollThreshold"
      :color="appBarColor"
      class="no-print elevation-0 si-app-toolbar"
      :style="`
      transition: top 0.2s ease 0s;
      ${_announcementActive && 'top: 48px;'} 
      `
      "
    >
      <v-toolbar-title
        class="cursor-pointer "
        @click="$router.push('/')"
      >
        <SiLogo
          size="28"
          :text-class="logoClass"
        />
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    
    <v-main>
      <router-view />
    </v-main>

    <v-footer
      v-if="!$route.meta.hideMainFooter"
      color="secondary"
      padless
    >
      <v-layout
        justify-center
        wrap
      >
        <template v-for="(link, i) in footerLinks">
          <v-btn
            :key="link.to"
            :to="link.type === 'to' ? link.to : undefined"
            :href="link.type === 'href' ? link.to : undefined"
            color="white"
            text
            rounded
            class="ma-3"
          >
            {{ link.text }}
          </v-btn>
          <v-divider
            v-if="i < (footerLinks || []).length - 1"
            :key="i"
            vertical
            color="white"
            class="my-2"
          />
        </template>
      </v-layout>
      <v-flex
        secondary
        darken-2
        py-4
        text-center
        white--text
        xs12
      >
        <SiLogo
          size="28"
          dark
        />
        <div class="mt-2 caption grey--text text--lighten-">
          © {{ new Date().getFullYear() }} Super Info | Version: {{ version }}
        </div>
      </v-flex>
    </v-footer>


    <v-snackbar
      :value="isOldVersion"
      :timeout="-1"
      color="warning"
    >
      A new version of Super Info is availabe. Reload to use latest version.
      <template #action>
        <v-btn
          text
          dark
          @click="reload"
        >
          Reload
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import { auth } from '@/plugins/firebase'
import clientPath from '@/plugins/client-path'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import version from '@/version.json'

export default {
  mixins: [ helpers, binder ],
  metaInfo () {
    let title = 'Super Info: Online Superannuation Calculators'
    let description = 'Automated superannuation calculators. Specialists in Australian Government superannuation schemes, including CSS, PSS, MSBS (MilitarySuper) and DFRDB.'
    let url = process.env.VUE_APP_BASE_URL
    let image = `${url}${require('@/assets/super_info-social_image.jpeg')}`
    return {
      title,
      titleTemplate: '%s | Super Info',
      meta: [
        { name: 'description', content: description },
        { name: 'author', content: 'Super Info' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: title },
        { property: 'og:url', content: url },
        { property: 'og:description', content: description },
        { property: 'og:image', content: image },
        { property: 'og:image:secure', content: image },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:title', content: title },
        { property: 'twitter:url', content: title },
        { property: 'twitter:description', content: description },
        { property: 'twitter:image', content: image },
      ]
    }
  },
  data () {
    return {
      toolbarVisible: true,
      loaderActive: false,
      scrollPos: 0,
      scrollThreshold: 1,
      footerLinks: [
        { text: 'Home', type: 'to', to: '/' },
        { text: 'Si Assist', type: 'to', to: '/assistance' },
        { text: 'The Bulletin', type: 'to', to: '/bulletin' },
        { text: 'Contact', type: 'to', to: '/contact' },
        { text: 'Privacy', type: 'to', to: '/privacy' },
        { text: 'Services Guide', type: 'to', to: '/services-guide' },
        { text: 'Blog', type: 'href', to: 'https://blog.superinfo.com.au' }
      ],
      systemVerion: {}
    }
  },
  computed: {
    ...mapGetters(['_loader', '_announcementActive']),
    logoClass () {
      return this.$route.name === 'home'
        ? this.scrollPos > this.scrollThreshold
          ? undefined
          : 'white--text'
        : undefined
    },
    appBarColor () {
      // return this.$route.name === 'home'
      //   ? this.scrollPos > this.scrollThreshold
      //     ? 'white'
      //     : 'transparent'
      //   : this.scrollPos > 10
      //     ? 'white'
      //     : 'transparent'
      return this.$route.meta.whiteToolbar 
        ? 'white'
        :  this.scrollPos > this.scrollThreshold 
          ? 'white' 
          : 'transparent'
    },
    version () {
      let { major, minor, build } = version
      return `${major}.${minor}.${build}`
    },
    systemVersionText () {
      let { major, minor, build } = this.systemVerion
      return `${major}.${minor}.${build}`
    },
    isOldVersion () {
      const number = (version = {}) => {
        let { major, minor, build } = version
        return Number(`${major}${minor}${build}`) || 0
      }
      return number(this.systemVerion) > number(version)
    }
  },
  watch: {
    '$route.params.page' () {
      this.toolbarVisible = false
      this.$nextTick(() => { this.toolbarVisible = true })
    },
    _loader (v) {
      if (v) {
        this.loaderActive = true
      } else {
        setTimeout(() => { this.loaderActive = false }, 500)
      }
    }
  },
  beforeMount () {
    var authWatch = auth.onAuthStateChanged(user => {
      if (user) {
        clientPath.init()
        this.$bindRtdbStore('set_calculators', 'calculators/_list', { loader: true })
        this.$bindRtdbStore('set_products', 'products')
        this.$bindRtdb('systemVerion', 'version')

        // this.$bindStorexxx(rtdb.ref('calculators/_list'), 'set_calculators', true)
        // this.$bindStorexxx(rtdb.ref('products'), 'set_products')
        // this.$bindxxx(rtdb.ref('version'), 'systemVerion')
        authWatch()
      }
    })
  },
  mounted () {
    clientPath.trackReferer()
  },
  methods: {
    onScroll (e) {
      this.scrollPos = e.target.scrollingElement.scrollTop
    },
    preRenderData (data, varName) {
      var script = document.createElement("script"); 
      script.innerHTML = "var " + varName + " = " + JSON.stringify(data) + ";"; 
      document.head.appendChild(script);
    },
    reload () {
      location.reload(true)
    }
  }
}
</script>


<style lang="scss">

</style>
